exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".noPadding{\n  padding-left:0px !important;\n}\n\n.eachLanguage{\n  padding-left:56px !important;\n}\n", ""]);

